document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault(); // Prevent the default anchor behavior

    const targetId = this.getAttribute('href'); // Get the target ID from the href attribute
    const targetElement = document.querySelector(targetId); // Find the target element

    if (targetElement) {
      // Scroll to the target element smoothly
      window.scrollTo({
        top: targetElement.offsetTop,
        behavior: 'smooth'
      });
    }
  });
});
